import React, { Component } from 'react';

import Conteudo from '../../Conteudo';
import Title from '../../components/Title';

import ListaAtividades from './ListaAtividades';
import ListaAtividadesPendentes from './ListaAtividadesPendentes';

import AuthProvider from '../../AuthProvider';

export default class extends Component {
  render() {
    return (
      <div>
        <Title value="Diego Rivera » Agenda" />
        <AuthProvider>
          {(_undefined, containsRole) => {
            let children = [];

            if (
              containsRole([
                'admin',
                'conselheiro',
                'sindico'
              ])
            ) {
              children.push(ListaAtividades, ListaAtividadesPendentes);
            } else if (containsRole(['porteiro', 'zelador'])) {
              children.push(ListaAtividades);
            }

            return (
              children.length && (
                <Conteudo>
                  {children.map((Child, i) => (
                    <Child key={i} />
                  ))}
                </Conteudo>
              )
            );
          }}
        </AuthProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/agenda/Index.js